// Interpreta el WMO weather code de Open-Meteo a emoji + texto corto en español.
export function weatherInfo(code: number): { emoji: string; text: string } {
  if (code === 0) return { emoji: '☀️', text: 'Despejado' };
  if (code <= 2) return { emoji: '🌤️', text: 'Parcial' };
  if (code === 3) return { emoji: '☁️', text: 'Nublado' };
  if (code <= 48) return { emoji: '🌫️', text: 'Niebla' };
  if (code <= 57) return { emoji: '🌦️', text: 'Llovizna' };
  if (code <= 67) return { emoji: '🌧️', text: 'Lluvia' };
  if (code <= 77) return { emoji: '🌨️', text: 'Nieve' };
  if (code <= 82) return { emoji: '🌧️', text: 'Chaparrón' };
  if (code <= 86) return { emoji: '🌨️', text: 'Nieve' };
  if (code >= 95) return { emoji: '⛈️', text: 'Tormenta' };
  return { emoji: '🌡️', text: '' };
}
